enum Privilege {
    READ = 'READ',
    WRITE = 'WRITE'
}

export default Privilege;
